function autoSizeRem() {
  document.getElementsByTagName('html')[0].style.fontSize = 100 * (window.innerWidth / 800) + 'px';
}
autoSizeRem();
window.onresize = autoSizeRem;
